import React, { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import { pageRoutes } from "../routes/PageRoutes";
import { useNavigate, useLocation } from "react-router-dom";
import SubHeader from "../components/SubHeader";
import { useDispatch, useSelector } from "react-redux";
import { fetchMaintenanceData } from "../redux/actions/servicePresetsActions";
import { pipViewDate } from "../auth/Pip";
import Loader from "../components/Loader";

const QuotesDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [isToggle, setIsToggle] = useState(false);

  const taskId = location.state?.taskId;

  const { maintananceData, isLoading } = useSelector(
    (state) => state?.servicePresetsReducer || {}
  );

  const onHandleClick = () => {
    setIsToggle(!isToggle);
  };

  useEffect(() => {
    if (taskId) {
      dispatch(fetchMaintenanceData({ payload: taskId }));
    }
  }, [dispatch, taskId]);

  if (isLoading || !maintananceData || maintananceData.taskId !== taskId) {
    return <Loader />;
  }

  const boatDetails = maintananceData.boatDetails || {};
  const services = maintananceData.services || [];

  return (
    <div className="ct_dashbaord_bg">
      <div className={`ct_dashbaord_main ${isToggle === false && "ct_active"}`}>
        <Sidebar path="customer-requests" />
        <div className="ct_content_right">
          <Header onClick={onHandleClick} />

          <div className="ct_px_23 ct_mt_30 pb-5">
            <div className="ct_mb_30">
              <div className="d-flex justify-content-between ct_flex_col_575 gap-3">
                <SubHeader />
              </div>
            </div>

            <div className="ct_bordeer_F2F4F7"></div>

            <div className="ct_mt_30">
              <div className="d-flex align-items-center gap-4 flex-wrap justify-content-between mb-3">
                <div>
                  <div className="ct_custom_badge" style={{ backgroundColor: "rgb(203, 247, 255)", color: "rgb(35, 192, 232)" }}>
                    <small className="ct_ff_ProximaNova_regular">Boat Owner</small>
                  </div>
                  <h5 className="ct_text_dark ct_fs_22 ct_fw_600 my-2">{boatDetails.ownerName || "-"}</h5>
                </div>
                <div className="ct_info_clr_box">
                  Quote {maintananceData.ownerApprovalStatus || "PENDING"}
                </div>
              </div>

              <div className="ct_mb_16">
                <span>
                  <svg className="me-1" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.96484 6.42833L7.78151 10.3067C8.58401 10.8408 8.98484 11.1083 9.41818 11.2125C9.80151 11.3042 10.2007 11.3042 10.5832 11.2125C11.0165 11.1083 11.4173 10.8408 12.2198 10.3067L18.0365 6.42833M5.96484 16.25H14.0365C15.4365 16.25 16.1365 16.25 16.6715 15.9775C17.1416 15.7377 17.5237 15.3553 17.7632 14.885C18.0365 14.35 18.0365 13.65 18.0365 12.25V7.75C18.0365 6.35 18.0365 5.65 17.764 5.115C17.5243 4.64462 17.1419 4.26218 16.6715 4.0225C16.1365 3.75 15.4365 3.75 14.0365 3.75H5.96484C4.56484 3.75 3.86484 3.75 3.32984 4.0225C2.85977 4.26232 2.47764 4.64474 2.23818 5.115C1.96484 5.65 1.96484 6.35 1.96484 7.75V12.25C1.96484 13.65 1.96484 14.35 2.23734 14.885C2.47702 15.3554 2.85946 15.7378 3.32984 15.9775C3.86484 16.25 4.56484 16.25 5.96484 16.25Z" stroke="#2F3849" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Email:{" "}
                </span>
                <span className="ct_text_dark ct_fs_16 ct_fw_600">{boatDetails.ownerEmail || "-"}</span>
              </div>
              
              <div>
                <span>
                  <svg className="me-1" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.64299 6.57247C4.40487 5.00122 5.51362 3.58747 7.20737 3.06872C7.5081 2.97668 7.83262 3.00284 8.11473 3.14186C8.39684 3.28088 8.61528 3.52229 8.72549 3.81685L9.26862 5.26685C9.35594 5.50009 9.3716 5.7541 9.31358 5.99631C9.25556 6.23851 9.12652 6.45786 8.94299 6.62622L7.32737 8.1081C7.24754 8.18119 7.18806 8.27376 7.15475 8.37675C7.12145 8.47973 7.11546 8.5896 7.13737 8.6956L7.15174 8.7606L7.19174 8.92372C7.22737 9.06122 7.28112 9.25497 7.35674 9.48622C7.50674 9.9456 7.74612 10.5631 8.10237 11.18C8.45862 11.7968 8.87362 12.3131 9.19612 12.6725C9.36422 12.8595 9.53978 13.0396 9.72237 13.2125L9.77237 13.2587C9.85318 13.3303 9.95115 13.3797 10.0567 13.4022C10.1623 13.4246 10.2719 13.4193 10.3749 13.3868L12.4661 12.7287C12.7037 12.654 12.9582 12.652 13.197 12.723C13.4357 12.7939 13.6478 12.9345 13.8061 13.1268L14.7955 14.3281C15.208 14.8281 15.1592 15.5631 14.6849 16.005C13.3886 17.2131 11.6061 17.4612 10.3661 16.4637C8.84657 15.2375 7.56529 13.7424 6.58612 12.0531C5.59975 10.3643 4.94054 8.50542 4.64299 6.57247ZM8.44674 8.77747L9.78799 7.54747C10.155 7.21074 10.4131 6.77204 10.5292 6.28764C10.6452 5.80323 10.6139 5.29521 10.4392 4.82872L9.89549 3.37872C9.67366 2.7863 9.23425 2.30078 8.66683 2.02114C8.0994 1.74149 7.44669 1.68877 6.84174 1.87372C4.73862 2.5181 3.04987 4.40372 3.40737 6.75935C3.72828 8.84804 4.44009 10.8575 5.50549 12.6825C6.56162 14.5042 7.94352 16.1164 9.58237 17.4387C11.4417 18.9325 13.9255 18.4231 15.5374 16.92C15.9988 16.4903 16.2789 15.9006 16.3204 15.2714C16.3618 14.6422 16.1616 14.0209 15.7605 13.5343L14.7711 12.3331C14.4545 11.9484 14.0302 11.667 13.5525 11.5251C13.0749 11.3832 12.5658 11.3873 12.0905 11.5368L10.3549 12.0831C10.2772 12.0032 10.2011 11.9217 10.1267 11.8387C9.76992 11.4442 9.45432 11.0143 9.18487 10.5556C8.98487 10.0928 8.7076 9.60448 8.54424 9.0981C8.50955 8.99211 8.47704 8.88542 8.44674 8.7781" fill="#2F3849"/>
                  </svg>
                  Contact No.:{" "}
                </span>
                <span className="ct_text_dark ct_fs_16 ct_fw_600">{boatDetails.ownerPhone || "-"}</span>
              </div>
            </div>

            <div className="ct_mt_30">
              <div className="d-flex gap-4 flex-wrap">
                <div>
                  <h6 className="mb-2 text-uppercase text-muted ct_fs_12">BOAT</h6>
                  <div className="ct_info_clr_box">
                    {boatDetails.boatName || "-"}
                  </div>
                </div>

                <div>
                  <h6 className="mb-2 text-uppercase text-muted ct_fs_12">REGISTRATION (REGO)</h6>
                  <div className="ct_info_clr_box">
                    {boatDetails.rego || "-"}
                  </div>
                </div>

                <div>
                  <h6 className="mb-2 text-uppercase text-muted ct_fs_12">Date Sent</h6>
                  <div className="ct_info_clr_box">
                    {maintananceData.createdAt ? pipViewDate(maintananceData.createdAt) : "-"}
                  </div>
                </div>

                <div>
                  <h6 className="mb-2 text-uppercase text-muted ct_fs_12">ESTIMATED DURATION</h6>
                  <div className="ct_info_clr_box">
                    {maintananceData.time_alloted || "0"} Hrs
                  </div>
                </div>
              </div>
            </div>

            <div className="ct_mt_30">
              <h3 className="ct_fs_16 ct_fw_600 mb-2 text-uppercase">Description</h3>
              <div className="edit-det-boat-det-box">
                <p className="mb-0 ct_max_height_250 ct_custom_scroll pe-2">
                  {maintananceData.description || "No description provided."}
                </p>
              </div>
            </div>

            <div className="ct_white_bg_1 ct_mt_40">
              <div className="d-flex align-items-center gap-3 justify-content-between flex-wrap ct_mb_14">
                <div className="ct_text_dark ct_fs_20 ct_fw_600">
                  Quote Details
                </div>
              </div>

              <div className="ct_bordeer_F2F4F7"></div>

              <div className="row ct_mt_30">
                <div className="col-lg-8 mb-3">
                  <div className="maintennce-service-wrapper d-grid gap-3">
                    {services.length > 0 ? (
                      services.map((srv, idx) => (
                        <div className="service-row" key={srv.taskServiceId || idx}>
                          <div className="service-left">
                            <div className="service-title ct_fs_16 ct_fw_700 ct_text_dark">
                              {srv.serviceName || "Service Item"}
                            </div>
                            <p className="service-desc ct_fs_14 ct_fw_400 ct_text_para mb-0">
                              Service ID: {srv.serviceId || "-"}
                            </p>
                          </div>
                          <div className="service-right">
                            <div className="price-block text-center">
                              <div className="price-label ct_fs_12 ct_fw_700 ct_text_para mb-1">
                                PRICE
                              </div>
                              <div className="price-value ct_fs_14 ct_fw_700">
                                <span className="dollar ct_text_para">
                                  <i className="fa-solid fa-dollar-sign me-1"></i>
                                </span>
                                {Number(srv.servicePrice || 0).toFixed(2)}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p className="text-muted">No service items in this quote.</p>
                    )}
                  </div>
                </div>

                <div className="col-lg-4 mb-3">
                  <div className="ct_white_bg p-4 ct_border_radius_8 ct_box_shadow_0000001C">
                    <div className="d-flex justify-content-between flex-wrap gap-3 align-items-center mb-3">
                      <h6 className="ct_fs_16 ct_fw_700 ct_text_dark">TOTAL COST <span className="ct_fs_14 ct_fw_400 ct_text_dark fst-italic ct_text_para">Estimated</span></h6>
                      <h6 className="ct_fs_18 ct_fw_700 ct_text_theme">${Number(maintananceData.totalCost || 0).toFixed(2)}</h6>
                    </div>

                    <div className="ct_bordeer_F2F4F7 my-3"></div>

                    <div>
                      <h5 className="ct_fs_14 ct_fw_600 ct_text_para mb-2 text-uppercase">Total Service cost</h5>
                      <h6 className="ct_fs_16 ct_fw_600 ct_text_dark">${Number(maintananceData.totalCost || 0).toFixed(2)}</h6>
                    </div>
                    
                    <div className="ct_bordeer_F2F4F7 my-3"></div>
                    
                    <div>
                      <h5 className="ct_fs_14 ct_fw_600 ct_text_para mb-2 text-uppercase">Estimated duration</h5>
                      <h6 className="ct_fs_16 ct_fw_600 ct_text_dark">{maintananceData.time_alloted || "0"} Hrs</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="ct_mt_30">
              <h3 className="ct_fs_16 ct_fw_600 mb-2 text-uppercase">Terms:</h3>
              <div className="edit-det-boat-det-box">
                <ul className="ps-3 mb-0">
                  <li className="ct_fs_16 ct_fw_400 ct_text_dark mb-1">Service cost includes labour only</li>
                  <li className="ct_fs_16 ct_fw_400 ct_text_dark mb-1">Parts will be charged separately</li>
                  <li className="ct_fs_16 ct_fw_400 ct_text_dark mb-0">Timeline may vary after inspection</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuotesDetail;
